import { render } from "./AboutLayout.vue?vue&type=template&id=bef5dcfa"
const script = {}

import "./AboutLayout.vue?vue&type=style&index=0&id=bef5dcfa&lang=css"

import exportComponent from "E:\\_PlonqProjects\\Dashboard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__